/* A single banner in the main purchase area, including editor rerenders. */
if (!customElements.get('duludah-product-promo')) {
  let queued = false;
  const reconcile = () => {
    queued = false;
    let visible = false;
    document.querySelectorAll('duludah-product-promo').forEach(banner => {
      const inPurchaseArea = banner.closest('main .product-details') && !banner.closest('dialog, quick-add-dialog, .product-card, .featured-product, .qa-only');
      banner.hidden = !inPurchaseArea || visible;
      if (!banner.hidden) visible = true;
    });
  };
  const schedule = () => { if (!queued) { queued = true; queueMicrotask(reconcile); } };
  class DuludahProductPromo extends HTMLElement {
    connectedCallback() {
      schedule();
      this.expire();
    }
    disconnectedCallback() { clearTimeout(this.timer); schedule(); }
    expire() {
      if (this.dataset.saleEnd && Date.now() >= Number(this.dataset.saleEnd) * 1000) {
        this.querySelector('[data-promo-sale]')?.remove();
        if (!this.children.length) { this.remove(); return; }
      } else if (this.dataset.saleEnd && this.isConnected) {
        clearTimeout(this.timer);
        const remaining = Number(this.dataset.saleEnd) * 1000 - Date.now();
        this.timer = setTimeout(() => this.expire(), Math.min(Math.max(remaining, 0), 2147483647));
      }
    }
  }
  customElements.define('duludah-product-promo', DuludahProductPromo);
  document.addEventListener('shopify:section:load', schedule);
}
